// @flow
import React from "react";
import ReactModal from "react-modal";
import cx from "classnames";

import styles from "./index.module.scss";

type PropsType = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  overlayClassName?: string;
  className?: string;
};

type BaseModalPropsType = PropsType & {
  isOpen?: boolean;
};

ReactModal.setAppElement("#root");
ReactModal.defaultStyles.content = {};

/*
  Modals:
  ReactModal uses the portal functionality of React to render the component at the root of the DOM,
  outside of the scope of React. It isn't rendered in semantic order. To implement a modal, just
  wrap your content with the <Modal> element at the bottom of your page component, or in some other
  component. Open/Closed state is managed in the ModalContextProvider. The className prop is passed
  to the Overlay of the modal, allowing you to position it wherever you want and control the margin.
*/

const Modal = ({
  children,
  className,
  overlayClassName,
  onClose,
  ...rest
}: BaseModalPropsType) => {
  return (
    <ReactModal
      className={cx(styles.Modal, className)}
      overlayClassName={cx(styles.Overlay, overlayClassName)}
      bodyOpenClassName={styles.Open}
      onRequestClose={onClose}
      {...rest}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
